import dayjs, { Dayjs } from "dayjs";

export const momentYMDHMS = (dayjs: Dayjs): string =>
  dayjs.format('YYYY-MM-DD HH:mm:ss');
